module.exports = __webpack_public_path__ + "static/media/mountain8.577215bc.jpg";